import { buttonVariants } from '@e2n/ui';
import { GradientStarIcon } from '@/assets/icons/GradientStarIcon';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

export function NewDesignBanner({
  link,
  onClick,
}: {
  link: string;
  onClick?: () => void;
}) {
  const { t } = useTranslation();

  return (
    <div className="w-full items-center justify-between px-10 py-2.5 bg-linear-to-r from-secondary-purple-100 via-slate-50 to-primary-blue-100 flex">
      <div className="flex items-center gap-2 text-sm font-medium text-gray-800">
        <GradientStarIcon />
        <span>{t('general.navigation.newDesignBanner')}</span>
      </div>
      <a
        href={link}
        onClick={onClick}
        className={cn(
          buttonVariants({
            size: 'sm',
            variant: 'outline-secondary',
          }),
          'font-normal',
        )}>
        {t('general.navigation.zumClassicDesign')}
      </a>
    </div>
  );
}
